// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteProjectGroupModal_dialog__2JArZ"};